import React from 'react';
import {FullscreenControl, Map, Placemark, YMaps} from 'react-yandex-maps';

const YMap = ({coordinates}) => {

    const mapState = {
        center: coordinates,
        zoom: 16,
    };

    const mapStyle = {
        width: '100%',
        height: "400px",
    };

    return (
        <YMaps>
            <Map style={mapStyle} defaultState={mapState} >
                <FullscreenControl />
                <Placemark geometry={mapState.center} />
            </Map>
        </YMaps>
    );
}

export default YMap;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/map.jsx